// extracted by mini-css-extract-plugin
module.exports = {"embla__container":"EmblaCarousel_embla__container__jdkxh","embla__slide":"EmblaCarousel_embla__slide__S7NGH"};